export async function createDriverMethodCollectingUseCase(repository, driverId, method, paymentValue) {
  if (!method) {
    return { success: false, data: null, error: "Selecciona un método de cobro." };
  }
  if (typeof paymentValue !== "string" || paymentValue.length > 255) {
    return { success: false, data: null, error: "La información de cobro debe tener como máximo 255 caracteres." };
  }

  const result = await repository.create({
    drivers_id: driverId,
    method_collecting_id: method.id,
    payment_value: paymentValue === "" ? null : paymentValue,
  });
  if (!result.success) return result;

  // Conserva los IDs de la asociación y del catálogo para futuras actualizaciones.
  return {
    ...result,
    data: {
      ...method,
      id: result.data.id,
      method_collecting_id: method.id,
      payment_value: result.data.payment_value,
    },
  };
}
